module.exports = __webpack_public_path__ + "img/lookbook_3_right.032605af.png";